module.exports = "<bulk-scripts-upload-page></bulk-scripts-upload-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkScriptsUpload.html
// module id = 2087
// module chunks = 0